import React, { useMemo, useState } from "react";
import "./Contact.css";
import { useLocalContext } from "../../context/LocalContext";

const Contact = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = {
    name: webinfo.name || "digivirtuehost.com",
    email: webinfo.email || "contact@digivirtuehost.com",
    phone: webinfo.phone || "+91 80000 00000",
    phonecall: webinfo.phonecall || "+918000000000",
    address: webinfo.address || "India • Remote-first worldwide",
    whatsapp: webinfo.whatsapp || "https://wa.me/918000000000",
    hours: webinfo.hours || "Mon–Sat · 10am–7pm IST",
  };

  const topics = useMemo(
    () => [
      "New shared / WordPress hosting",
      "VPS or cloud server",
      "Domain transfer / DNS help",
      "Migration from another host",
      "SSL, email, or deliverability",
      "Other",
    ],
    []
  );

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    topic: "",
    consent: false,
    honey: "",
  });

  const [status, setStatus] = useState("");

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((s) => ({ ...s, [name]: type === "checkbox" ? checked : value }));
  };

  const submit = (e) => {
    e.preventDefault();
    if (form.honey) return;
    if (!form.name || !form.email || !form.message || !form.consent) {
      setStatus("Please complete all required fields.");
      return;
    }
    setStatus("Thanks! We’ll get back to you shortly.");
    setForm({
      name: "",
      email: "",
      message: "",
      topic: "",
      consent: false,
      honey: "",
    });
  };

  return (
    <section className="contactv6">
      <div className="cv6-wrap">
        <header className="cv6-head">
          <span className="cv6-eyebrow">Contact</span>
          <h1>Let’s discuss your project</h1>
          <p>
            Tell us what you’re building, the goal behind it, and your timeline.
            We’ll respond with clear recommendations and next steps.
          </p>
        </header>

        <div className="cv6-grid">
          {/* FORM */}
          <div className="cv6-card">
            <h2>Send a message</h2>
            <form onSubmit={submit}>
              <input
                type="text"
                name="honey"
                value={form.honey}
                onChange={onChange}
                className="hp"
              />

              <label>
                Name
                <input
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  placeholder="Your full name"
                />
              </label>

              <label>
                Email
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="you@company.com"
                />
              </label>

              <label>
                Topic
                <select name="topic" value={form.topic} onChange={onChange}>
                  <option value="">Select</option>
                  {topics.map((t) => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
              </label>

              <label>
                Message
                <textarea
                  rows="5"
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  placeholder="Briefly explain your requirement"
                />
              </label>

              <label className="check">
                <input
                  type="checkbox"
                  name="consent"
                  checked={form.consent}
                  onChange={onChange}
                />
                I agree to be contacted regarding this inquiry.
              </label>

              <button className="primary" type="submit">Send message</button>

              {status && <p className="status">{status}</p>}
            </form>
          </div>

          {/* INFO */}
          <aside className="cv6-side">
            <div className="cv6-card soft">
              <h3>Direct contact</h3>
              <p>
                Prefer quick communication? Reach out during <strong>{brand.hours}</strong>.
              </p>

              <ul>
                <li>
                  <span>Email</span>
                  <a href={`mailto:${brand.email}`}>{brand.email}</a>
                </li>
                <li>
                  <span>Phone</span>
                  <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
                </li>
                <li>
                  <span>Location</span>
                  {brand.address}
                </li>
              </ul>

              <a
                className="ghost"
                href={brand.whatsapp}
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp chat
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Contact;
